import { DiscountCode } from "views/discounts/types";
import moment from "moment";
import { Copy01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { formatDiscountValue } from "views/discounts/utils/discountCalculations";
import { handleCopy } from "utils/handleCopy";
import { cx } from "shared/utils";

interface DiscountCodesDisplayTableProps {
  discounts: DiscountCode[];
  showConfigureButton?: boolean;
}

export const DiscountCodesDisplayTable = ({
  discounts,
  showConfigureButton
}: DiscountCodesDisplayTableProps) => {
  // Filter out CUSTOM discount codes
  const filteredDiscounts = discounts.filter(
    (discount) => !discount.code.startsWith("CUSTOM-")
  );

  return (
    <table className="min-w-full">
      <thead>
        <tr
          className={cx(
            "text-left text-xs text-content-300 border-y border-alpha-40 h-[44px]",
            !showConfigureButton ? "bg-background-900" : ""
          )}
        >
          <th className="font-medium pl-6">Discount code</th>
          <th className="font-medium">Start date</th>
          <th className="font-medium">End date</th>
          <th className="w-[100px] font-medium pr-6">Value</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-alpha-40">
        {filteredDiscounts.map((discount) => (
          <tr key={discount.id} className="h-[80px]">
            <td className="pl-6">
              <div className="flex items-center">
                <IconButton
                  size={IconButtonSize.SM}
                  variant={IconButtonVariant.TEXT}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(discount.code, "Discount code copied!");
                  }}
                  title="Copy code"
                  HugeIcon={Copy01Icon}
                  className="!text-content-200 !hover:text-content-400"
                />
                <span className="text-sm font-bold text-content-1000 ml-2">
                  {discount.code}
                </span>
              </div>
            </td>
            <td className="text-sm text-content-500">
              {discount.start_date
                ? moment(discount.start_date).format("ll")
                : "-"}
            </td>
            <td className="text-sm text-content-500">
              {discount.end_date ? moment(discount.end_date).format("ll") : "-"}
            </td>
            <td className="text-sm text-content-1000 font-medium w-[100px] pr-6">
              {formatDiscountValue(discount)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
